<template>
    <div class="login-form-wrapper">
        <div class="login-form">
            <form @submit.prevent="submit" id="login-form">

                <div class="field has-flex-label has-validation">
                    <label>
                        <span>Usuario</span>
                        <span class="error">Please enter a valid username</span>
                    </label>
                    <div class="control is-bigger has-icon">

                        <input class="input" type="text" name="username" id="login-username" v-model="form.username">

                        <div class="form-icon">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </div>
                        <div class="error-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </div>
                    </div>
                </div>

                <div class="field has-flex-label has-validation">
                    <label>
                        <span>Contraseña</span>
                        <span class="error">Minimum 8 characters</span>
                    </label>
                    <div class="control is-bigger has-icon">

                        <input class="input" type="password" name="password" id="login-password" v-model="form.password">

                        <div class="form-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                        </div>
                        <div class="error-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </div>
                    </div>
                </div>

                <div class="button-wrap">
                    <button id="login-submit" type="submit"
                        class="button primary-button upper-button raised is-fullwidth is-rounded"
                        :disabled="loading">
                        <span v-show="!loading">Login</span>
                        <div class="small-auth-loader" v-show="loading">
                            <div class="loader is-loading"></div>
                        </div>
                    </button>
                </div>
            </form>

            <small class="has-text-danger has-text-centered"><em>{{errors}}</em></small>

            <!-- <div class="flex-field"> -->
                <div class="forgot-link has-text-centered">
                    <router-link tag="a" :to="{name: 'auth.recover'}">Restablecer Contraseña</router-link>
                </div>
                <div class="back-link has-text-centered">
                    <a href="https://bambi.com.ar/">Volver al portal de Bambi</a>
                </div>
            <!-- </div> -->

        </div>
    </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'signin',
    created(){
        this.clearAuthErrors()
        this.clearLoading()
    },
    components: {
        //
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors',
            loading: 'auth/loading'
        }),
    },
    data(){
        return{
            form:{
                username: '',
                password: ''
            }
        }
    },
    methods:{
        ...mapActions({
            signIn: 'auth/signIn',
            clearAuthErrors: 'auth/clearAuthErrors',
            clearLoading: 'auth/clearLoading'
        }),
        submit(){
            this.signIn(this.form)
            .catch(() => {
                console.log("El registro ha fallado!");
            })
        }
    }
}
</script>


<style>
.small-auth-loader div{
    margin: 0px auto;
}
</style>